import { render, staticRenderFns } from "./Ntcr.vue?vue&type=template&id=1ec44c84&"
import script from "./Ntcr.vue?vue&type=script&lang=js&"
export * from "./Ntcr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Ntcr.vue"
export default component.exports